import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.scss"],
    standalone: false
})
export class ButtonComponent {
    @Input() public text: string = "Click me";
    @Input() public type: "primary" | "secondary" = "primary";
    @Input() public size: "small" | "medium" | "large" = "medium";
    @Input() public disabled: boolean = false;


    @Output() buttonClick = new EventEmitter<void>();

    public onClick = () => !this.disabled && this.buttonClick.emit();
}